var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKeyMageTool = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  imageRendering: "optimizeQuality",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  viewBox: "0 0 512 509.939",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M467.741 267.225c-29.508 29.507-68.357 44.26-107.168 44.26-27.525 0-55.065-7.421-79.28-22.259L60.581 509.939 2.067 451.424l29.258-29.258L0 390.842l37.804-37.806 31.326 31.325 9.609-9.609-46.357-46.357 41.01-41.01 46.357 46.357 103.056-103.056c-14.744-24.161-22.12-51.694-22.121-79.255h-.168c0-38.81 14.752-77.657 44.258-107.163C274.29 14.756 313.135 0 351.946 0s77.66 14.756 107.167 44.263l8.631 8.632C497.249 82.4 512 121.247 512 160.057h-.167c-.002 38.919-14.704 77.779-44.092 107.168m-60.198-60.185c12.993-12.995 19.489-30.023 19.489-46.983h-.168c0-17.062-6.438-34.096-19.312-46.97l-8.632-8.631c-12.877-12.878-29.911-19.32-46.974-19.32-17.064 0-34.097 6.442-46.975 19.32-12.881 12.881-19.319 29.912-19.319 46.975h-.168c0 16.96 6.498 33.988 19.485 46.975l8.632 8.632c12.874 12.872 29.906 19.31 46.972 19.31 17.064 0 34.098-6.438 46.97-19.308"
})));
export { SvgKeyMageTool as ReactComponent };
export default __webpack_public_path__ + "assets/images/key-mage-tool.svg";